import { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { API_GET, DBRequest, useConfig } from '../../../api/api';
import ExoAvatar from '../../exo/ExoAvatar';
import TypeSkeleton from './TypeSkeleton';
import FormHelperText from '../FormHelperText';

// parse a stored config value ("[1,2]") into user ids
function parseIds(value) {
  if (Array.isArray(value)) return value.map(Number);
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(Number) : [];
  } catch (e) {
    return [];
  }
}

/**
 * Multi select of users for the settings: config values are strings, so the
 * selected user ids are stored as a JSON list ("[1,2]").
 */
const TypeConfigUsers = ({
  updateValidationOnChange,
  dataCollection,
  field,
  size,
}) => {
  const config = useConfig();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!config) return;
    DBRequest({
      config,
      path: 'users',
      method: API_GET,
      onResponse: (res) => setUsers(res.data || []),
      onLoading: setIsLoading,
    });
  }, [config]);

  const selectedIds = parseIds(dataCollection[field.key]);

  function handleChange(e) {
    updateValidationOnChange(field.key, JSON.stringify(e.target.value));
  }

  const userLabel = (user) =>
    `${user.salutation ? user.salutation + ' ' : ''}${user.firstName} ${user.lastName}`;

  if (isLoading) return <TypeSkeleton size={size} />;

  return (
    <FormControl fullWidth size={size}>
      <InputLabel id={`config-users-${field.key}`} shrink>
        {field.label}
      </InputLabel>
      <Select
        multiple
        labelId={`config-users-${field.key}`}
        label={field.label}
        value={selectedIds.filter((id) => users.some((u) => u.id === id))}
        onChange={handleChange}
        displayEmpty
        notched
        renderValue={(selected) => (
          <Box className="flex flex-wrap items-center gap-2">
            {users
              .filter((user) => selected.includes(user.id))
              .map((user) => (
                <Box key={user.id} className="flex items-center gap-1">
                  <ExoAvatar
                    picture={user.picture ? user.picture.thumbnailUrl : ''}
                    name={`${user.firstName} ${user.lastName}`}
                    size="28px"
                    type="contact"
                  />
                  {userLabel(user)}
                </Box>
              ))}
          </Box>
        )}
      >
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id} className="flex gap-2">
            <ExoAvatar
              picture={user.picture ? user.picture.thumbnailUrl : ''}
              name={`${user.firstName} ${user.lastName}`}
              size="32px"
              type="contact"
            />
            {userLabel(user)}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText />
    </FormControl>
  );
};

export default TypeConfigUsers;
